(function () {
  'use strict'

  angular.module('MktzapApp.Factories')
    .factory('ActiveLogService', ActiveLogService)

  ActiveLogService.$inject = ['$resource']

  function ActiveLogService ($resource) {
    return $resource(apiUrl + '/active-log/:id', { id: '@id' }, {
      checkAnsweredFromWebhook: { url: apiUrl + '/active-log/answered-from-webhook', method: 'POST', params: {}, isArray: false }
    })
  }
})();
